import {isFeatureEnabled} from 'feature-flags';

import {useLocation} from 'react-router-dom';

import {featureFlags} from '@dms/feature-flags';
import {sourcingRoutes} from '@dms/routes';
import {useNavigationBreadCrumb} from '@dms/shared';

import {useIsMobileNavigation} from './useIsMobileNavigation';

export function useIsPageNavigationVisible() {
  const location = useLocation();
  const [breadcrumbProps, isBreadcrumbVisible] = useNavigationBreadCrumb();
  const isMobileNavigation = useIsMobileNavigation();
  const rowControlDetail = breadcrumbProps?.rowControlDetail;

  const isSourcingPage = location.pathname.includes(sourcingRoutes.home);

  const shouldHideNavigation =
    isFeatureEnabled(featureFlags.ENTITY_HEADER_V2) &&
    isMobileNavigation &&
    (location.pathname.includes('vehicles') || location.pathname.includes('business-case'));

  if (shouldHideNavigation) {
    return false;
  }

  return Boolean(isBreadcrumbVisible || rowControlDetail || isSourcingPage);
}
